import { FormattedMessage, useIntl } from 'react-intl'
import { Table, TableContainer, Tbody, Td, Thead, Th, Tr } from 'components/v2/Table'

import { rewardTypeMessages } from 'features/Loyalty/components/RewardType/messages'
import { safeFormatMessage } from 'utils/intl'
import { ReactElement } from 'react'
import { IRewardsListProps } from './types'

const RewardsList = ({ rewards }: IRewardsListProps): ReactElement => {
  const { items } = rewards
  const intl = useIntl()

  return (
    <TableContainer overflow>
      <Table marginBottom>
        <Thead>
          <Tr>
            <Th>
              <FormattedMessage id="loyalty.rewards.list.column.name" defaultMessage="Reward Name" />
            </Th>
            <Th>
              <FormattedMessage id="loyalty.rewards.list.column.description" defaultMessage="Description" />
            </Th>
            <Th>
              <FormattedMessage id="loyalty.rewards.list.column.unlocked" defaultMessage="Unlocked" />
            </Th>
            <Th>
              <FormattedMessage id="loyalty.rewards.list.column.redimed" defaultMessage="Redeemed" />
            </Th>
            <Th>
              <FormattedMessage id="loyalty.rewards.list.column.type" defaultMessage="Type" />
            </Th>
            <Th>
              <FormattedMessage id="loyalty.rewards.list.column.company" defaultMessage="Company" />
            </Th>
          </Tr>
        </Thead>

        <Tbody>
          {items.map((reward) => {
            return (
              <Tr key={reward.id}>
                <Td>{reward.name}</Td>
                <Td>{reward.description}</Td>
                <Td>{reward.earnedCount}</Td>
                <Td>{reward.redeemedCount}</Td>
                <Td>{safeFormatMessage({ intl, messages: rewardTypeMessages, key: reward.type })}</Td>
                <Td>{reward.company.name}</Td>
              </Tr>
            )
          })}
        </Tbody>
      </Table>
    </TableContainer>
  )
}

export default RewardsList
